import HTTP from "../http";

const serverTime = async () => {
  try {
    const response = await HTTP.normal.get("/what-time-is-it");

    return response.data;
  } catch (e) {
    throw e;
  }
};

export default {
  serverTime
};



// WEBPACK FOOTER //
// ./src/api/modules/server.js